export default "* Arkæologiske fund\n* Boplads\n* Hule\n* Bygge\n* Materialer\n";